import { useQuery } from 'react-query'
import { AxiosResponse } from 'axios'

import { PATH } from '../../constants/global'
import { useAPI } from '..'

import { UseConnections, Connection } from './types'

// As of 01-07-26 filterByRole can now accept multiple roles using comma separated values, e.g. '4,7'
// This has been left as a string type rather than an array type as it is not a breaking API change
export default (filterByRole?: string): UseConnections => {
   const request = useAPI()

   const { data, isLoading, isError } = useQuery(
      `connections${filterByRole ? `filterByRole${filterByRole}` : ''}`,
      getConnectionsFromAPI
   )

   async function getConnectionsFromAPI(): Promise<
      AxiosResponse<Connection[]>
   > {
      // Used to grab a list of connections with a certain role
      if (filterByRole) {
         return await request.get(`${PATH.CONNECTIONS.FILTERABLE_LIST}?includeActiveFilterOption=false&userRole=${filterByRole}`)
      }
      return await request.get(PATH.CONNECTIONS_FILTER.LIST)
   }

   return {
      list: data?.data || ([] as Connection[]),
      isLoading,
      isError,
   }
}
